<template>
  <div class="gp-loading-overlay">
    <loading :active.sync="loadingFlag" :is-full-page="fullPage">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 40"
        class="groove-logo speed-1"
      >
        <path
          d="M19.722 19.852h19.326c-.829 8.975-4.942 14.896-12.34 17.763-7.397 2.866-14.386 1.433-20.966-4.3l6.906-6.626c2.51 1.84 4.869 2.76 7.074 2.76 2.206 0 4.268-.844 6.186-2.532l-6.186-7.065zM0 19.36h9.909c.391-4.854 2.702-7.9 6.933-9.137 4.23-1.236 7.798.038 10.702 3.822l7.73-6.309C28.764.456 21.24-1.686 12.701 1.312 4.814 4.08.581 10.097 0 19.36z"
        ></path>
      </svg>
    </loading>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading,
  },
  props: ['isLoading', 'fullPage'],
  watch: {
    isLoading(newValue) {
      this.loadingFlag = newValue;
    },
  },
  data() {
    return {
      loadingFlag: this.isLoading,
    };
  },
};
</script>

<style lang="scss">
.gp-loading-overlay {
  .groove-logo {
    height: 61px;
    width: 60px;
    stroke: #fd6481;
    fill: #fd6481;
    stroke-dasharray: 600;
    stroke-width: 0.6;
    opacity: 1;
    animation: pinkIt 4s cubic-bezier(0, 0.23, 1, 0.1);
    animation-delay: 0s;
    -moz-animation: pinkIt 4s cubic-bezier(0, 0.23, 1, 0.1);
    -webkit-animation: pinkIt 4s cubic-bezier(0, 0.23, 1, 0.1);
    stroke-linecap: round;

    &.speed-2 {
      animation-duration: 1s;
    }
  }

  @keyframes pinkIt {
    0%,100%{
      fill:none;
      stroke-dashoffset: 600;
      fill:rgba(255,255,255,0);
      opacity: 0;
    }
    20%{
      fill:rgba(255,255,255,0);
      opacity: 1;
      stroke-dashoffset: 600;
    }
    60%{
      fill:#FD6481;
      stroke-dashoffset: 0;
    }
  }
}
</style>